var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeafDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 53.143,
    height: 83.6316,
    viewBox: "0 0 53.143 83.6316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "leaf 7",
    d: "M15.338 8.4139C16.538 8.4139 14.3094 1.19195 19.0238 0.104125C24.1239 -1.07271 23.5667 8.10784 25.4525 8.4139C26.4811 8.58084 28.7954 4.98769 31.7526 6.52922C35.0289 8.23713 29.8414 13.5413 32.524 16.0812C34.1526 17.6233 38.36 9.62191 42.9813 10.2987C49.0242 11.1837 33.0383 28.503 38.4812 30.8159C42.2099 32.4003 46.7273 24.2114 52.11 26.1043C58.3672 28.3048 33.8526 46.9214 41.0956 48.335C44.3259 48.9655 47.9471 44.9142 49.5385 46.9214C51.3385 49.1917 49.1584 53.451 46.4528 56.0878C44.7384 57.7584 39.3812 60.7996 38.7384 63.0269C37.1545 68.5145 33.4662 72.7375 28.0239 73.6341C28.0111 73.6362 27.9984 73.6383 27.9856 73.6404C27.4472 73.9363 30.0296 83.4266 27.1239 83.6303C25.2381 83.7625 27.4846 73.9595 25.9239 73.796C20.1721 73.6437 15.8029 68.0447 13.9237 65.5541C11.2839 62.0554 3.0601 60.8452 4.88073 56.8589C5.74691 54.9623 8.59194 56.2944 9.29508 54.3316C10.538 50.8622 -3.35343 45.0344 0.76638 37.8407C4.49501 31.3301 8.73461 36.6503 9.29508 35.6561C11.0094 32.615 -0.120272 27.9941 2.65212 23.4915C6.42361 17.3663 10.1309 23.3423 12.1665 19.8933C13.7845 17.1521 3.96114 13.2612 8.52364 7.85706C10.838 5.11583 14.138 8.4139 15.338 8.4139Z",
    fill: "url(#paint0_linear_0_53)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_53",
    x1: 26.5715,
    y1: 83.6316,
    x2: 20.7304,
    y2: -28.2833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A35C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4DCD0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafDot);
export default __webpack_public_path__ + "static/media/leaf-dot.69401d929f2f8603a04d9900b3aedce6.svg";
export { ForwardRef as ReactComponent };